import { createSelector } from 'reselect';
import { getCollectionsNew } from '../collections';

export const getCollectionSettings = createSelector([getCollectionsNew], (collection) => ({
  title: collection.title,
  name: collection.name,
  eventDate: collection.eventDate,
  userBrand: collection.userBrand,
  password: collection.password,
  language: collection.language,
  comment: collection.comment,
  commentsMode: collection.commentsMode,
  like: collection.like,
  download: collection.download,
  downloadPin: collection.downloadPin,
  downloadPinActive: collection.downloadPinActive,
  globalDownloadState: collection.globalDownloadState,
  globalWatermarkID: collection.globalWatermarkID,
  singleImageDownloadDisabled: collection.singleImageDownloadDisabled,
  responsiveImages: collection.responsiveImages,
  showAppInstall: collection.showAppInstall,
  showImageCaptionInGallery: collection.showImageCaptionInGallery,
  caching: collection.caching,
  sharing: collection.sharing,
  expirationDate: collection.expirationDate,
  security: collection.security,
  faceRecognition: collection.faceRecognition,
  tags: collection.tags,
  mainCustomers: collection.mainCustomers,
  receiver: collection.receiver,
  messages: collection.messages
}));
